import type { RetrieveResult } from 'src/components/molecules/AddressSearch/services/loqate';
import { retrieve } from 'src/components/molecules/AddressSearch/services/loqate';

export type Address = {
  address1: string;
  address2?: string;
  country: string;
  county?: string;
  postcode?: string;
  town: string;
};

export const getAddress = async (id: string, country: string): Promise<Address | void> => {
  const retrieveResult = await retrieve(id, country);
  if (retrieveResult.length) {
    return marshallToAddress(retrieveResult[0]);
  }
};

const marshallToAddress = (addressData: RetrieveResult): Address => {
  const { Company, Line1, Line2 } = addressData;
  const address1 = Company || Line1;
  const address2 = Company ? [Line1, Line2].filter(Boolean).join(', ') : Line2;

  return {
    address1: address1 as string,
    address2,
    town: addressData.City,
    county: addressData.ProvinceName,
    postcode: addressData.PostalCode,
    country: addressData.CountryIso2,
  };
};
